import { LogLevel, LogType, Logger } from '@gef-ui/logging';
export const logApiError = (err, middleware = 'api')=>Logger.log({
        middleware,
        message: 'Error occurred when parsing response body.',
        err
    }, LogLevel.ERROR, LogType.ERROR);
export const logApiInfoError = (err, middleware = 'api')=>Logger.info({
        middleware,
        message: 'Error while calling be',
        err
    }, LogLevel.INFO, LogType.INFO);
export const logHeaderEnhancerDebug = (enhancerName, callAPI)=>Logger.debug(`Calling action enhanced using ${enhancerName} with ${JSON.stringify(callAPI.headers)} headers.`);
export const logApiActionDebug = (callAPI, params, endpoint)=>Logger.debug(`Calling action: ${callAPI.actionName} to endpoint: ${endpoint ?? callAPI.endpoint} with params: ${JSON.stringify(params)}`);
